export { default } from './PageTouristAgency.vue'
